import { defineMessages } from 'react-intl';

export const messages: {
	checkIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	checkIconLabel: {
		id: 'company-hub.color-picker.pressable-color-tile.check-icon-label',
		description:
			'Accessible label of the presable / button-like color tile when the user has selected the color of this tile among the many available',
		defaultMessage: 'Selected',
	},
});
